import {
  Category,
  createCategory,
  createVariantList,
  deleteCategory,
  deleteVariantList,
  editCategory,
  editVariantList,
  getCategory,
  GetManyVariantIndexDto,
  getVariantIndexData,
  getVariantList,
  IVariantIndexData,
  IVariantIndexResult,
  VariantList
} from '@/@core/services/app.service'
import { formatDate } from '@/@core/utils/utils'
import Index from '@/views/analyze/Index'
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TableContainer,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Stack,
  Divider,
  FormControlLabelProps,
  styled,
  useRadioGroup
} from '@mui/material'
import { Box } from '@mui/system'
import { Close, Plus } from 'mdi-material-ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { getCode } from '@/@core/layouts/utils'

interface NObject {
  [key: string]: any
}

interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean
}

const StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  '.MuiFormControlLabel-label': checked && {
    color: theme.palette.primary.main
  }
}))

function MyFormControlLabel(props: FormControlLabelProps) {
  const radioGroup = useRadioGroup()

  let checked = false

  if (radioGroup) {
    checked = radioGroup.value === props.value
  }

  return (
    <StyledFormControlLabel
      labelPlacement="start"
      checked={checked}
      {...props}
    />
  )
}

const VariantLists = (props: any) => {
  const { t } = useTranslation()
  const [categoryName, setCategoryName] = React.useState<string>('')
  const [isAdd, setIsAdd] = React.useState(false)
  const [value, setValue] = React.useState('')
  const [category, setCategory] = React.useState<Category[]>([])
  const [data, setData] = React.useState<any[]>([])
  const [selectRowKey, setSelectRowKey] = React.useState<any[]>([])
  const [Indexs, setIndexs] = React.useState<IVariantIndexData[]>([])

  const columns2: GridColDef[] = [
    {
      field: 'chromPriority',
      headerName: 'chrom',
      width: 70,
      editable: true,
      disableColumnMenu: true,
      renderCell: (row) => {
        return row.row.chrom
      }
    },
    {
      field: 'pos',
      headerName: t('Position'),
      width: 100,
      editable: true,
      disableColumnMenu: true
    },
    {
      field: 'ref',
      editable: true,
      headerName: 'REF',
      width: 90,
      disableColumnMenu: true
    },
    {
      field: 'alt',
      headerName: 'ALT',
      width: 90,
      editable: true,
      disableColumnMenu: true
    },
    {
      field: 'gene',
      headerName: t('Gene'),
      width: 90,
      editable: true,
      disableColumnMenu: true
    },
    {
      field: 'pnomen',
      headerName: 'cNomen & pNomen',
      width: 90,
      editable: true,
      disableColumnMenu: true,
      sortable: false
    },
    {
      field: 'Index',
      headerName: t('Index'),
      width: 90,
      renderCell: (row) => {
        return row.row.Index
          ? `${row.row.Index.accountTotal}/${row.row.Index.platformTotal}`
          : ''
      },
      disableColumnMenu: true,
      sortable: false
    },
    {
      field: 'Actions',
      headerName: t('Actions'),
      width: 90,
      renderCell: (row) => {
        return (
          <Stack maxWidth={'100%'} spacing={1}>
            <Box>
              <Button
                sx={{ color: 'white !important' }}
                size="small"
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation()
                  if (!row.row.isAdd) deleteVariantLists.mutateAsync(row.row.id)
                  else setData(data.filter((item) => item.id !== row.row.id))
                }}
              >
                {t('delete')}
              </Button>
            </Box>
          </Stack>
        )
      },
      disableColumnMenu: true,
      sortable: false
    }
  ]

  const Tables = (data: any[]) => {
    return (
      <div style={{ height: 400, width: '100%' }}>
        <Button
          size="small"
          variant="contained"
          sx={{ mr: 4 }}
          onClick={() => {
            setData([
              ...data,
              {
                id: getCode(),
                isAdd: true
              }
            ])
          }}
        >
          {t('add')}
        </Button>

        <Button
          size="small"
          variant="contained"
          onClick={() => {
            //
          }}
        >
          {t('save')}
        </Button>

        <DataGrid
          rows={rows}
          columns={columns2}
          editMode="row"
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 100 }
            }
          }}
          processRowUpdate={(params) => {
            //

            let chromPriority = params.chromPriority

            if (chromPriority == '23') {
              chromPriority = 'X'
            } else if (chromPriority == '24') {
              chromPriority = 'Y'
            } else if (chromPriority == '25') {
              chromPriority = 'MT'
            }

            setData(
              data.map((item) => {
                if (item.id === params.id) {
                  return {
                    ...params,
                    chrom: chromPriority
                  }
                }

                return item
              })
            )

            if (params.key) editVariantLists.mutateAsync({ ...params })
            else {
              const createParams = {
                categoryId: Number(value),
                key: getCode(),
                chrom: chromPriority,
                pos: Number(params.pos),
                ref: params.ref,
                alt: params.alt,
                pnomen: params.pnomen,
                cnomen: params.cnomen,
                gene: params.gene
              }

              createVariantLists.mutateAsync(createParams)
            }
          }}
          disableRowSelectionOnClick
          sx={{
            maxHeight: 350
          }}
        />
      </div>
    )
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    getVariantLists.mutateAsync({
      categoryId: +(event.target as HTMLInputElement).value
    })

    setValue((event.target as HTMLInputElement).value)
  }

  const { refetch } = useQuery({
    queryFn: () => getCategory(),
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data && data.list) {
        setCategory(data.list)
      } else {
        setCategory([])
      }
    }
  })

  const getVariantLists = useMutation({
    mutationFn: async (data: { categoryId: number }) =>
      await getVariantList(data),
    onSuccess: (data) => {
      //post返回的结果
      if (data && data.list) {
        const indexParams: GetManyVariantIndexDto = {
          genomeBuild: props.analysisInfo.genomeBuild,
          variants: data.list.map(
            (item: { chrom: any; pos: any; ref: any; alt: any }) => {
              return {
                chrom: `${item.chrom}` as any,
                pos: item.pos,
                REF: item.ref,
                ALT: item.alt
              }
            }
          )
        }

        getIndex.mutateAsync(indexParams)

        setData(data.list)
      } else setData([])
    }
  })

  const getIndex = useMutation({
    mutationFn: async (data: GetManyVariantIndexDto) =>
      await getVariantIndexData(data),
    onSuccess: (datas: IVariantIndexResult[]) => {
      //post返回的结果
      // setOMIM(datas)
      setIndexs(datas)
    }
  })

  const deleteVariantLists = useMutation({
    mutationFn: async (data: number) => await deleteVariantList(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      getVariantLists.mutateAsync({
        categoryId: value as unknown as number
      })
    }
  })

  const editVariantLists = useMutation({
    mutationFn: async (data: VariantList) => await editVariantList(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      getVariantLists.mutateAsync({
        categoryId: value as unknown as number
      })
    }
  })

  const createVariantLists = useMutation({
    mutationFn: async (data: VariantList) => await createVariantList(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      getVariantLists.mutateAsync({
        categoryId: value as unknown as number
      })
    }
  })

  const addCategory = useMutation({
    mutationFn: async (data: Category) => await createCategory(data),
    onSuccess: (data) => {
      //post返回的结果
      refetch()

      setIsAdd(false)

      setCategoryName('')
    }
  })

  const rows = React.useMemo(() => {
    return data.map((items) => {
      const tempIndex = Indexs.find(
        (item) =>
          item.key === `${items.chrom}_${items.pos}_${items.ref}_${items.alt}`
      )
      if (tempIndex) items.Index = tempIndex
      if (items.pos) items.pos = Number(items.pos)

      if (items.chrom) {
        if (items.chrom === 'X') {
          items.chromPriority = 23
        } else if (items.chrom === 'Y') {
          items.chromPriority = 24
        } else if (items.chrom === 'MT') {
          items.chromPriority = 25
        } else {
          items.chromPriority = Number(items.chrom)
        }
      }

      return items
    })
  }, [data, Indexs])

  React.useEffect(() => {
    if (category && category.length && !value) {
      handleChange({
        target: {
          value: category[0].id
        }
      } as any)
    }
  }, [category])

  return (
    <Box>
      <DialogTitle
        sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between' }}
        id="customized-dialog-title"
      >
        {t('Variant list')}

        <Stack direction={'row'} spacing={4} sx={{ mr: 10 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const config = {}

              props.setConfig && props.setConfig(config)

              props.handleClose()
            }}
          >
            {t('reset')}
          </Button>

          <Button
            variant="contained"
            size="small"
            onClick={() => {
              if (data && data.length) {
                //
                const config = {
                  userLocusIn: data.map((item) => {
                    return {
                      chrom: item.chrom,
                      pos: item.pos,
                      ref: item.ref,
                      alt: item.alt
                    }
                  })
                }

                props.setConfig && props.setConfig(config)
              } else {
                const config = {}

                props.setConfig && props.setConfig(config)
              }

              props.handleClose()
            }}
          >
            {t('Filter')}
          </Button>
        </Stack>
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500]
        }}
      >
        <Close />
      </IconButton>

      <DialogContent
        dividers
        sx={{
          overflow: 'auto',
          maxHeight: 500,
          minHeight: 300,
          width: 1200
        }}
      >
        <Grid container height={'100%'} spacing={6}>
          <Grid item xs={5} md={4}>
            {isAdd ? (
              <Box width={'100%'} padding={2}>
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label={t('name')}
                  variant="outlined"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />

                <Grid container justifyContent={'end'} marginTop={'10px'}>
                  <Grid item>
                    <Button
                      sx={{ marginRight: '10px' }}
                      onClick={() => {
                        setIsAdd(false)
                      }}
                    >
                      {t('cancel')}
                    </Button>

                    <Button
                      variant="contained"
                      onClick={() => {
                        if (categoryName)
                          addCategory.mutateAsync({
                            name: categoryName,
                            userId: null,
                            createdAt: formatDate(new Date()),
                            updatedAt: formatDate(new Date()),
                            isPublic: 1
                          })
                      }}
                      autoFocus
                    >
                      {t('create')}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <Button
                sx={{
                  py: 1,
                  ml: 8
                }}
                variant="contained"
                onClick={() => {
                  setIsAdd(true)
                }}
              >
                {`${t('create')} ${t('Variant list')}`}
              </Button>
            )}

            <FormControl
              fullWidth
              sx={{
                maxHeight: 400,
                overflow: 'auto',
                overflowX: 'hidden',
                pb: 4
              }}
            >
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChange}
                sx={{
                  '& .MuiFormControlLabel-root': {
                    justifyContent: 'space-between',
                    px: 4
                  }
                }}
              >
                {category.map((item) => {
                  return (
                    <MyFormControlLabel
                      value={`${item.id}`}
                      label={item.name}
                      control={<Radio />}
                    />
                  )
                })}
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* <Divider flexItem orientation="vertical" /> */}

          <Grid item xs={7} md={8}>
            {Tables(data)}
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  )
}

export default VariantLists
